"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.userColumnProps = exports.userTypes = void 0;
const constants_1 = require("utils/constants");
exports.userTypes = {
    ON_RESET: 'USER TYPES ON RESET',
    SET_ERROR: 'USER TYPES ON ERROR',
    ON_DELETE: 'USER TYPES ON DELEtE',
    GET_DETAIL: 'USER TYPES ON GET DETAIL',
    SET_DATA_GRID: 'USER TYPES GET DATA GRID',
    ON_PAGE_CHANGE: 'USER TYPES ON PAGE CHANGE',
    ON_MUTATION_CLICK: 'USER TYPES ON MUTATION',
    GET_CHECKPOINT: 'USER TYPES ON GET CHECKPOINT',
    ON_FILTER_CHANGE: 'USER TYPES ON FILTER CHANGE',
    ON_SAVE_DATAITEM: 'USER TYPES ON SAVE DATAITEM',
    ON_CHANGE_DATAITEM: 'USER TYPES ON CHANGE DATAITEM',
};
exports.userColumnProps = [
    {
        show: true,
        field: 'fullname',
        title: 'Fullname',
        width: '220',
        filter: 'text'
    },
    {
        show: true,
        field: 'username',
        title: 'Username',
        width: '180',
        filter: 'text'
    },
    {
        show: true,
        field: 'contractor_name',
        title: 'Company',
        width: '220',
        filter: 'text'
    },
    {
        show: true,
        field: 'department',
        title: 'Department',
        width: '200',
        filter: 'text'
    },
    {
        show: true,
        field: 'role_name',
        title: 'Role',
        width: '160',
        filter: 'text'
    },
    {
        show: true,
        field: 'operator_access_value',
        title: 'Pos / Silo / Hopper',
        width: '200',
        filter: 'text'
    },
    {
        show: true,
        field: 'modified_date',
        title: 'Modified Date',
        width: '220',
        filter: 'date',
        format: `${constants_1.formatGridDate.ddMMYYYY} ${constants_1.formatGridDate.hhMM}`
    },
    {
        show: true,
        field: 'modified_by',
        title: 'Modified By',
        width: '180',
        filter: 'text'
    },
    {
        show: true,
        field: 'is_active',
        title: 'Status',
        width: '120',
        filter: 'boolean'
    },
];
